export default {
	ApiHost: 'https://platform.elteren.lu/api',
	PragmaToken: 'default=Pie,T<ethoh6mohlaecie<Sh4thahc7vait:'
}